import { render, staticRenderFns } from "./ReceiptCodeRegistration.vue?vue&type=template&id=bea236dc&scoped=true&"
import script from "./ReceiptCodeRegistration.vue?vue&type=script&lang=js&"
export * from "./ReceiptCodeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptCodeRegistration.vue?vue&type=style&index=0&id=bea236dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea236dc",
  null
  
)

export default component.exports